import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import PropTypes from 'prop-types';
// import classnames from 'classnames';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
// import red from '@material-ui/core/colors/red';
import Button from 'components/CustomButtons/Button.jsx';
// import Tooltip from "@material-ui/core/Tooltip";
import Badge from "components/Badge/Badge.jsx";
import Accordion from "components/Accordion/Accordion.jsx";
// icons

// carousel
import PropertyCarousel from "./PropertyCarousel";
// import avatarImg from "images/avatars/avatar_me.jpg";
// import Avatar from "@material-ui/core/Avatar";
import ContactTable from "./ContactTable.jsx"
import Description from "./Description.jsx"

import {
  Phone,
  MailOutline,

} from '@material-ui/icons';


const styles = theme => ({
  label: {
    marginRight: '10px'
  },
  avatar: {
    width: '200px',
    height: '200px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    marginBottom: "50px"
  },
  tooltip: {
    padding: "10px 15px",
    minWidth: "130px",
    color: "#555555",
    lineHeight: "1.7em",
    background: "#FFFFFF",
    border: "none",
    borderRadius: "3px",
    boxShadow:
      "0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",
    maxWidth: "200px",
    textAlign: "center",
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    fontSize: "0.875em",
    fontStyle: "normal",
    fontWeight: "400",
    textShadow: "none",
    textTransform: "none",
    letterSpacing: "normal",
    wordBreak: "normal",
    wordSpacing: "normal",
    wordWrap: "normal",
    whiteSpace: "normal",
    lineBreak: "auto"
  }
});

class PropertyData extends React.Component {
  state = { expanded: false };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  render() {
    const { classes } = this.props;
    const { oportunity } = this.props;
    return (
      <Grid container
        // alignItems='center'
        spacing={8}
        justify="flex-start">

        <Grid item
        lg={4}
        md={4}
        xl={4}
        xs={4}>
          <PropertyCarousel images={oportunity.attributes.images}/>
          <Divider variant="middle" />
          <Typography align="center" variant="body2"  color="textSecondary" gutterBottom>
            LOFT
          </Typography>
          <Typography align="center" variant="body1" color="textPrimary" gutterBottom>
            {oportunity.attributes.title}
          </Typography>

          <Divider variant="middle" />

          <Typography
            color="textSecondary"
            variant="body2"
            align="center"
            gutterBottom
          >
            {oportunity.attributes.short_description}
          </Typography>

        </Grid>

        <Grid item
        lg={8}
        md={8}
        xl={8}
        xs={8}>

          <Grid container>
            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} variant="body2" inline align="left" color="textPrimary" gutterBottom>
                Name:
              </Typography>
              <Typography inline align="left" variant="body1" color="textSecondary" gutterBottom>
                {oportunity.attributes.title}
              </Typography>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} variant="body2" inline align="left" color="textPrimary" gutterBottom>
                Description:
              </Typography>
              <Typography inline align="left" variant="body1" color="textSecondary" gutterBottom>
                {oportunity.attributes.description}
              </Typography>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
              <Typography className={classes.label} variant="body2" inline align="left" color="textPrimary" gutterBottom>
                Objectives:
              </Typography>
              <Typography inline align="left" variant="body1" color="textSecondary" gutterBottom>
                {oportunity.attributes.goals}
              </Typography>
            </Grid>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} variant="body2" inline align="left" color="textPrimary" gutterBottom>
                ROI:
              </Typography>
              <Typography inline align="left" variant="body1" color="textSecondary" gutterBottom>
                {oportunity.attributes.roi} %
              </Typography>
            </Grid>

            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                Creation date:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {oportunity.attributes.created_at}
              </Typography>
            </Grid>


            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
            <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
              Last update:
            </Typography>
            <Typography inline align="left" variant="body2"  color="textSecondary" gutterBottom>
              {oportunity.attributes.updated_at}
            </Typography>
            </Grid>



            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                Notes:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {oportunity.attributes.notes}
              </Typography>
            </Grid>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                Public name:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {oportunity.attributes.public_name}
              </Typography>
            </Grid>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                Public description:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {oportunity.attributes.public_description}
              </Typography>
            </Grid>

            <Grid item
            lg={1}
            md={1}
            xl={1}
            xs={1}>
            { oportunity.attributes.active === true
              ? <Badge color="success">active</Badge>
              : <Badge>inactive</Badge>
            }
          </Grid>


            <Grid item
            lg={5}
            md={5}
            xl={5}
            xs={5}>
            { oportunity.attributes.public === true
              ? <Badge color="success">public</Badge>
              : <Badge>private</Badge>
            }
            </Grid>

            <Grid item
            lg={5}
            md={5}
            xl={5}
            xs={5}>
              <Badge color="info">Ask validation</Badge>
            </Grid>

            <Grid item
              lg={12}
              md={12}
              xl={12}
              xs={12}
              >
              <Accordion
                active={-1}
                collapses={[
                  {
                    title: " Description",
                    content:
                    <Description />
                  },
                  {
                    title: " Public name and description",
                    content:
                      <ContactTable />
                  },
                  {
                    title: " Objectives",
                    content:
                      <ContactTable />
                  }
                ]}
                />
            </Grid>

        </Grid>
        </Grid>
      </Grid>

    );
  }
}

PropertyData.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PropertyData);
